import { Input } from '@cokitchen/cokitchen-components';
import React from 'react';
import { ReactComponent as RestoreIcon } from 'assets/icons/restore.svg';
import './styles.scss';
import { MealAddonCategoryType } from 'utils/types';
const TrashedAddonCategoryCard = ({
  data,
  onChange,
  onRestore,
  selectedItems
}: {
  data: MealAddonCategoryType;
  onChange: () => void;
  onRestore: () => void;
  selectedItems: string[];
}) => {
  return (
    <div className='accordion_header py-3 bg-white px-4 flex gap-4 items-center'>
      <div className='flex gap-2 items-center'>
        <Input
          type='checkbox'
          name='new'
          checked={selectedItems.includes(data?.id)}
          checkColor='gray'
          onClick={(e) => {
            e.stopPropagation();
            onChange?.();
          }}
          className=' mr-3 z-40'
        />
        <div className='w-8 h-8'>
          {selectedItems.length === 0 && (
            <div
              onClick={onRestore}
              className='bg-white border border-gray-13 w-8 h-8 rounded-full flex justify-center items-center cursor-pointer hover:bg-gray-1 bg-opacity-70'>
              <RestoreIcon />
            </div>
          )}
        </div>
      </div>
      <p className='text-base font-medium'>{data.name}</p>
    </div>
  );
};

export default TrashedAddonCategoryCard;
